// extracted by mini-css-extract-plugin
export default {"add-issue-form":"components-parity-parity-manager-add-issue-form-module__add-issue-form"};